<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">Bracket</div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->

    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div class="grid grid-cols-2">
      <mat-stepper orientation="vertical" #stepper>
        <mat-step
          [stepControl]="firstFormGroup"
          errorMessage="circuit is required."
        >
          <form [formGroup]="firstFormGroup">
            <ng-template matStepLabel>Choisir votre circuit</ng-template>
            <app-recherche
              #CircuitSearchComponent
              [style]="{ width: '100%' }"
              [api]="generalService.api"
              champsAffiche="Tiers_RS"
              [numColonneToShow]="0"
              [numColonneToReturn]="1"
              (ChampEnter)="onSelectCircuit($event)"
              recherche="Travel"
              [tbrecherche]="getStructureRechercheCircuit()"
              [param]="longRangeTime"
              name="Circuit"
              placeholder="Nom Ciruit"
            >
            </app-recherche>

            <!-- <mat-form-field appearance="outline" class="w-full mx-2">
            <mat-label
              style="
                font-weight: bold;
                font-size: 25px;
                margin-left: 0;
                padding-right: 17px;
              "
              >Circuit</mat-label
            >
            <input
              type="text"
              matInput
              placeholder="entrez nom de circuit"
              [matAutocomplete]="auto1"
              [formControl]="circuitCtrl"
              formControlName="firstCtrl"
              required
            />
            <mat-autocomplete
              #auto1="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)="circuitChange($event.option.value)"
            >
              <mat-option
                *ngFor="let circuit of filteredCircuit | async"
                [value]="circuit"
              >
                {{ circuit.Travel_Nom }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->
            <div>
              <p>Passez à une autre étape pour voir l'état de l'erreur</p>
              <button mat-button matStepperNext>Suivant</button>
            </div>
          </form>
        </mat-step>
        <mat-step errorMessage="Address is required.">
          <ng-template matStepLabel
            >Remplissez votre plage de dates</ng-template
          >
          <unilog-date-picker
            [label]="'Date debut'"
            style="width: 50%"
            [(date)]="date_Debut"
            (dateChange)="onChangeGlobalDates(DS_circuit)"
          >
          </unilog-date-picker>
          <unilog-date-picker
            [label]="'Date fin'"
            class="w-36"
            [(date)]="date_Fin"
            (dateChange)="onChangeGlobalDates(DS_circuit)"
          >
          </unilog-date-picker>

          <!-- <mat-form-field appearance="outline">
          <mat-label>Du</mat-label>
          <input
            matInput
            [matDatepicker]="dateDebut"
            placeholder="Du"
            [(ngModel)]="date_Debut"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateDebut"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateDebut></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Au</mat-label>
          <input
            matInput
            [matDatepicker]="dateFin"
            placeholder="Au"
            [(ngModel)]="date_Fin"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="dateFin"
          ></mat-datepicker-toggle>
          <mat-datepicker #dateFin></mat-datepicker>
        </mat-form-field> -->
          <div>
            <p>Passez à une autre étape pour voir l'état de l'erreur</p>
            <button mat-button matStepperPrevious>Retour</button>
            <button mat-button matStepperNext>Suivant</button>
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel
            >Remplissez votre liste nombre de personnes</ng-template
          >

          <mat-form-field class="w-full">
            <mat-label>nbr personnes</mat-label>
            <input
              pattern="\d*"
              matInput
              #postalCode
              [maxLength]="4"
              placeholder="Ex. 20"
              (keydown.enter)="addNumberToList(postalCode)"
            />
            <mat-hint align="end">{{ postalCode.value.length }} / 4</mat-hint>
          </mat-form-field>
          <div>
            <ng-container *ngFor="let nbrPerso of listNbrPerso; index as i">
              <!-- <span
              style="padding: 5px 10px 5px 10px"
              class="rounded-full bg-blue-700 text-white font-bold text-center mx-2"
              >{{ nbrPerso }}
            </span> -->

              <span
                class="inline-flex items-center font-semibold rounded-full px-4 py-0.5 mr-2 mt-1 bg-indigo-100 text-indigo-800"
              >
                {{ nbrPerso }}
                <button
                  type="button"
                  class="flex-shrink-0 ml-1 focus:outline-none"
                  (click)="removeOptionNbrPerso(i)"
                >
                  <svg class="w-20 h-20 fill-current" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M10 0a10 10 0 100 20 10 10 0 000-20zM6.364 6.364a.5.5 0 01.707 0L10 9.293l2.93-2.93a.5.5 0 11.707.707L10.707 10l2.93 2.93a.5.5 0 11-.707.707L10 10.707l-2.93 2.93a.5.5 0 01-.707-.707L9.293 10 6.364 7.07a.5.5 0 010-.707z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </span>
            </ng-container>
          </div>

          <p>Vous avez maintenant terminé.</p>
          <div>
            <button mat-button matStepperPrevious>Retour</button>
            <button mat-button (click)="stepper.reset()">Réinitialiser</button>
          </div>
        </mat-step>
      </mat-stepper>

      <div class="flex flex-col pt-8">
        <div class="w-full flex items-center space-x-3">
          <button
            mat-raised-button
            color="primary"
            class="w-full text-xl py-2"
            (click)="
              HandleCalculBraquetPerDates(
                DS_circuit,
                listNbrPerso,
                dates_changed_list
              )
            "
          >
            <!-- <mat-icon *ngIf="loadingBraquetCalucul"
              ><mat-spinner diameter="20" color="accent"> </mat-spinner
            ></mat-icon> -->

            <mat-icon *ngIf="!loadingBraquetCalucul">settings</mat-icon>
            <mat-icon
              *ngIf="loadingBraquetCalucul"
              class="spin-icon"
              aria-label="loading"
              role="status"
            >
              settings
            </mat-icon>
            exécuter simulation braquet
          </button>

          <button
            *ngIf="braquetService.BraquetMatrixResult?.length > 0"
            mat-raised-button
            class="text-xl bg-indigo-900 text-white w-full py-2"
            (click)="removDataFromLocalStorageAndResetValues()"
          >
            <mat-icon>delete_outline</mat-icon>
            écraser ce braquet
          </button>
        </div>

        <div class="mt-5">
          <table class="">
            <tr>
              <th class="empty"></th>
              <th *ngFor="let item of listNbrPerso">{{ item }}</th>
            </tr>

            <tr *ngFor="let period of PeriodsList; index as i">
              <td class="align">
                <span class="text-gray-600 text-sm font-semibold">du:</span>
                {{ period.startDate | date : "dd/MM/YYYY" }}

                <span class="text-gray-600 text-sm font-semibold">au:</span>
                {{ period.endDateToDisplay | date : "dd/MM/YYYY" }}
              </td>

              <td
                *ngFor="
                  let tarif of period.values;
                  index as j;
                  trackBy: trackByIndex
                "
                [class]="getColorClass(j)"
                class="text-sm"
                (click)="
                  gotoReservationWithCodeBraquet(
                    DS_circuit.Travel[0].Travel_Code,
                    tarif.code
                  )
                "
              >
                {{
                  tarif.value[tarif.value?.length - 1]["Total"]
                    | currency : "TND" : "symbol"
                }}

                <div class="text-xs mt-2">
                  ( PU:
                  {{
                    tarif.value[tarif.value?.length - 1]["Prix individuel"]
                      | currency : "TND" : "symbol"
                  }}
                  )
                </div>
                <div class="text-xs">
                  T Supp:
                  {{
                    tarif.value[tarif.value?.length - 1]["Total Supp"]
                      | currency : "TND" : "symbol"
                  }}
                </div>

                <div class="text-sm text-red-300">
                  {{ period.error ? period.error : "" }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- <div class="grid grid-cols-2 gap-4 mt-5 mx-6">
      <div class="example-table-container">
        <h2>Hotels</h2>
        <table
          mat-table
          [dataSource]="listHotels_fournisseurs"
          class="mat-elevation-z8 demo-table"
        >



          <ng-container matColumnDef="day">
            <th mat-header-cell *matHeaderCellDef>Jour</th>
            <td mat-cell *matCellDef="let element">
              jour {{ element.TravelD_Jour - 1 }}
            </td>
          </ng-container>


          <ng-container matColumnDef="tiers-rs">
            <th mat-header-cell *matHeaderCellDef>hotel</th>
            <td mat-cell class="cursor-pointer" *matCellDef="let element">
              {{ element.Tiers_RS }}
            </td>
          </ng-container>


          <ng-container matColumnDef="tiers-ville">
            <th mat-header-cell *matHeaderCellDef>Ville</th>
            <td mat-cell class="cursor-pointer" *matCellDef="let element">
              {{ element.TravelD_Ville }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsHotel"></tr>
          <tr
            mat-row
            (click)="
              fournisseurSelected = row;
              clickedRows.add(row);
              get_Traifs_byFrournisseur(row.Tiers_code)
            "
            [class.demo-row-is-clicked]="clickedRows.has(row)"
            *matRowDef="let row; let i = index; columns: displayedColumnsHotel"
            [ngClass]="{ 'bg-blue-50': i % 2 === 0, 'bg-white': i % 2 !== 0 }"
          ></tr>
        </table>
      </div>

      <div class="example-table-container">
        <h2>Restaurants</h2>
        <table
          mat-table
          [dataSource]="listRestaurants"
          class="mat-elevation-z8 demo-table"
        >
          <ng-container matColumnDef="day">
            <th mat-header-cell *matHeaderCellDef>Jour</th>
            <td mat-cell *matCellDef="let element">
              jour {{ element.TravelD_Jour - 1 }}
            </td>
          </ng-container>


          <ng-container matColumnDef="tiers-rs">
            <th mat-header-cell *matHeaderCellDef>restaurant</th>
            <td mat-cell *matCellDef="let element">{{ element.Tiers_RS }}</td>
          </ng-container>


          <ng-container matColumnDef="tiers-event">
            <th mat-header-cell *matHeaderCellDef>event</th>
            <td mat-cell *matCellDef="let element">
              {{ element.TravelD_Event }}
            </td>
          </ng-container>


          <ng-container matColumnDef="tiers-ville">
            <th mat-header-cell *matHeaderCellDef>Ville</th>
            <td mat-cell *matCellDef="let element">
              {{ element.TravelD_Ville }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsResto"></tr>
          <tr
            mat-row
            *matRowDef="let row; let i = index; columns: displayedColumnsResto"
            [ngClass]="{ 'bg-blue-50': i % 2 === 0, 'bg-white': i % 2 !== 0 }"
          ></tr>
        </table>
      </div>
    </div> -->

    <!-- <div class="example-table-container col-span-2 mb-6 mx-6">
      <div class="flex item-center justify-start">
        <h2 style="padding-top: 20px">
          Tarifs : <strong>{{ fournisseurSelected?.Tiers_code }}</strong>
        </h2>
      </div>
      <table
        mat-table
        [dataSource]="backUp_listeTarif"
        class="mat-elevation-z8 demo-table-tarif"
      >
        
        <ng-container matColumnDef="Tarif_index">
          <th mat-header-cell *matHeaderCellDef>No.</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Tarif_index }}
          </td>
        </ng-container>

        
        <ng-container matColumnDef="Type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Type }}
          </td>
        </ng-container>

        
        <ng-container matColumnDef="Tarif">
          <th mat-header-cell *matHeaderCellDef>Tarif</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Tarif | currency : "TND" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Date_Deb">
          <th mat-header-cell *matHeaderCellDef>Date_Deb</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Date_Deb | date }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Date_Fin">
          <th mat-header-cell *matHeaderCellDef>Date_Fin</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Date_Fin | date }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Tiers_code">
          <th mat-header-cell *matHeaderCellDef>Tiers_code</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Tiers_code }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Valide">
          <th mat-header-cell *matHeaderCellDef>Valide</th>
          <td mat-cell *matCellDef="let element">
            {{ element.Valide }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsTarif"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsTarif"></tr>
      </table>
    </div> -->
  </mat-card-content>
</mat-card>
